export function removeIllegalChars (filename: string) {
  // Define the illegal characters for most operating systems
  const illegalChars = /[/:*?"<>|]/g; 

  // Replace all illegal characters with an underscore
  return filename.replace(illegalChars, '_'); 
}